import React from "react"
import {FieldManagementPreviewProps} from "../../../render/management-preview";
import FieldView from "../../../render/view";


export default function FieldNumber_ManagementPreview(props: FieldManagementPreviewProps) {

    const model : any = {}
    model[props.field.fieldId] = "123.45"

    return <FieldView field={props.field} model={model} />
}